import {eq} from '@shared/helpers/lang'

import {selectCardPromotionGroup, clearSelectedCardPromotion} from '@web/actions/cardPromotion'
import {BannerType} from '@web/core/constants'
import {BannerState, BannerView, getBannerArea} from '@web/slices/banner/slice'
import makeSlice from '@web/slices/banner/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

/** 카드프로모션 미적용 시 기본 플레이트 배너를 표시하도록 필터링하는 함수 */
const getEasyPayPlateIndex = (banners: BannerView[]) => {
    return banners.findIndex(({bannerType}) => eq(bannerType, BannerType.PLATE_BANNER))
}

/**
 * 카드프로모션 적용 시
 * - 카드사 프로모션이라면, cardCompanyCode 일치하는 프로모션 배너 index
 * - 카드상품 프로모션이라면, cardCompanyCode와 cardPromotionProductNameCode 일치하는 프로모션 배너 index
 */
const getEasyPayPromotionIndex = (
    banners: BannerView[],
    cardPromotionCompanyCode: string,
    cardPromotionProductNameCode: Maybe<string>,
) => {
    if (!cardPromotionProductNameCode) {
        return banners.findIndex(
            ({bannerType, cardCompanyCode}) =>
                eq(bannerType, BannerType.PROMOTION_PLATE_BANNER) && eq(cardCompanyCode, cardPromotionCompanyCode),
        )
    }

    return banners.findIndex(
        ({bannerType, cardCompanyCode, cardProductNameCode}) =>
            eq(bannerType, BannerType.PROMOTION_PLATE_BANNER) &&
            eq(cardCompanyCode, cardPromotionCompanyCode) &&
            eq(cardProductNameCode, cardPromotionProductNameCode),
    )
}

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {
                    data: {banner, products},
                } = payload

                state.bannerArea = getBannerArea(banner.bannerListsByExposureAreaType as BannerState['bannerArea'])
                state.expectedTotalRewardPointBySubscribing = banner.expectTotalRewardPointBySubscribing ?? 0
                state.expectedTotalRewardPointOfTodayOrders = banner.expectTotalRewardPointOfTodayOrders ?? 0
                state.plccExpectedPercentage = banner.plccExpectedPercentage
                state.plccMaximumAmount = banner.plccMaximumAmount
                state.userName = banner.userName
                state.unappliedMembershipInflowBenefits =
                    banner.unappliedMembershipInflowBenefits?.map((benefit) => ({
                        amount: benefit.unappliedMembershipInflowBenefitExpectedRewardAmount ?? 0,
                        eventType: benefit.inflowBenefitEventType ?? '',
                    })) ?? []
                state.naverBenefit = products.some(({naverBenefit}) => naverBenefit)
            })
            .addCase(selectCardPromotionGroup.fulfilled, (state, {payload: {cardCompanyCode, cardProductNameCode}}) => {
                state.availableBannerArea['EASY_PAY_CREDIT_CARD'] = getEasyPayPromotionIndex(
                    state.bannerArea.EASY_PAY_CREDIT_CARD ?? [],
                    cardCompanyCode,
                    cardProductNameCode,
                )
            })
            .addCase(clearSelectedCardPromotion, (state) => {
                state.availableBannerArea['EASY_PAY_CREDIT_CARD'] = getEasyPayPlateIndex(
                    state.bannerArea.EASY_PAY_CREDIT_CARD ?? [],
                )
            })
    },
})

export default slice.reducer

export const actions = slice.actions
